import React from "react";
import { EdhProtocolAttributePageInitialState, PageNewState } from ".";

export const EdhProtocolAttributePageContext = React.createContext({
  pageState: EdhProtocolAttributePageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
